import { render, staticRenderFns } from "./ManageUsersGroupsTable.vue?vue&type=template&id=7328f30a&scoped=true"
import script from "./ManageUsersGroupsTable.vue?vue&type=script&lang=js"
export * from "./ManageUsersGroupsTable.vue?vue&type=script&lang=js"
import style0 from "./ManageUsersGroupsTable.vue?vue&type=style&index=0&id=7328f30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7328f30a",
  null
  
)

export default component.exports